import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import { restructureData } from "../../../../utils/restructureData";
import { validateLeadershipTable } from "../../../../utils/validateTable";
import StaticColumn from "./StaticColumn";

import ReviewBox from "../../../../Components/Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";

const GRI303_1 = ({hide}) => {
  const [table, setTable] = useState([]);
  const [table1, setTable1] = useState([]);
  const [defaultUnit, setDefaultUnit] = useState("");
  const [tabErrors, setTabErrors] = useState({});
  const [tabErrors1, setTabErrors1] = useState({});
  const [disabled, setDisabled] = useState(false);
  const inputData = [
    [
      {
        fieldName: "waterInteraction",
        title:
          "a. Interactions with water in kiloliters, including details on water withdrawal, consumption, discharge & water-related impacts",
        type: "array",
        // letter: "a.",
        tables: table,
        setTables: setTable,
        setErros: setTabErrors,
        errors: tabErrors,
        defaultSegments: [
          "Water Withdrawal",
          "Consumption",
          "Discharge",
          "Water-Related Impacts",
        ],
        paramater: "interactions",
        fields: [
          {
            fieldName: "interactions",
            title: "Interactions In",
            type: "text",
            placeholder: "Enter Text",
            width: "20%",
          },
          {
            fieldName: "response",
            title: "Response",
            type: "text",
            width: "22%",
            placeholder: "Enter Text",
          },
          {
            fieldName: "quntity",
            title: "Quantity",
            type: "number",
            width: "17%",
            placeholder: "Enter Number",
          },
          // {
          //   fieldName: "unit",
          //   title: "Unit",
          //   type: "select",
          //   options: ["m3", "kiloliters"],
          //   width: "18%",
          //   placeholder: "Select",
          // },
          {
            fieldName: "remark",
            title: "Remark",
            type: "text",
            width: "25%",
            placeholder: "Enter Text",
          },
        ],
      },
    ],
    [
      {
        fieldName: "waterWithdrawal",
        title:
          "b. Specify the sources of water withdrawal and provide details on locations and quantities in kiloliters.",
        tables: table1,
        setTables: setTable1,
        setErros: setTabErrors1,
        errors: tabErrors1,
        type: "array",
        defaultSegments: [
          "Water Withdrawal",
          "Water Consumption",
          "Water Discharge",
        ],
        // letter: "b.",
        paramater: "category",
        fields: [
          {
            fieldName: "category",
            title: "Water Category",
            type: "text",
            placeholder: "Enter Text",
            width: "5rem",
          },
          {
            fieldName: "source",
            title: "Sources",
            type: "select",
            options: [
              "Surface Water",
              "Ground Water",
              "Seawater",
              "Industrial Produced Water",
              "Third-party water",
              "Others",
            ],
            width: "7rem",
            placeholder: "Select",
          },
          {
            fieldName: "quntity",
            title: "Quantity",
            type: "number",
            width: "6rem",
            placeholder: "Enter Number",
          },

          {
            fieldName: "location",
            title: "Location",
            type: "text",
            width: "8rem",
            placeholder: "Enter Text",
          },
        ],
      },
    ],
  ];

  const questionData = [
    {
      fieldName: "waterImpactManagementDescription",
      title:
        "c. Describe how water-related impacts are addressed, including how the organization works with stakeholders to steward water as a shared resource, and how it engages with suppliers or customers with significant water-related impacts.",
      type: "text",
      placeholder: "Enter Text",
      // letter: "c.",
    },
    {
      fieldName: "waterGoalsAndTargetsExplanation",
      title:
        "d. Explain the process for setting any water-related goals and targets that are part of the organization’s approach to managing water and effluents, and how they relate to public policy and the local context of each area with water stress.",
      type: "text",
      placeholder: "Enter Text",
      // letter: "d.",
    },
  ];

  const navigate = useNavigate();
  const { id } = useParams();

  const [errors, setErrors] = useState({});
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({
    waterImpactManagementDescription: "",
    waterGoalsAndTargetsExplanation: "",
  });
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const [griReview, setGriReview] = React.useState(() => JSON.parse(localStorage.getItem("griReview")));
  React.useEffect(() => {
    const handleStorage = () => setGriReview(JSON.parse(localStorage.getItem("griReview")));
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);
  React.useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI300`);
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      const res1 = res?.data?.data?.GRI300?.sharedResource;
      console.log(res1);
      setData(res1);
      setFormData({
        waterImpactManagementDescription:
          res1?.waterImpactManagementDescription || "",
        waterGoalsAndTargetsExplanation:
          res1?.waterGoalsAndTargetsExplanation || "",
      });
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    if (!disabled) {
      let v1 = validateLeadershipTable(
        inputData[0],
        table,
        setTabErrors,
        "",
        inputData?.[0]?.[0]?.paramater
      );
      let v2 = validateLeadershipTable(
        inputData[1],
        table1,
        setTabErrors1,
        "",
        inputData?.[1]?.[0]?.paramater
      );

      if (!v1 || !v2) return;

      let transformedData2 = {
        sharedResource: {
          ...restructureData(table),
          ...restructureData(table1),
          ...formData,
        },
        type: "GRI300",
        submitted303_1: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res?.data?.message,
          severity: "success",
        });
        navigate(`/gri/gri300/303-2/${id}`);
      } catch (error) {
        console.log(error);
        setsnackOpen({
          open: true,
          message: error?.data?.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri300/303-2/${id}`);
    }
  };


  const renderContent = ({hide}) => (
      <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {!hide && <p className={styles.section_heading} style={{marginBottom : hide ? "-1rem" : "0", }}>303 : Water & Effluents</p>}
      <p className={styles.main_heading} style={{marginBottom : hide ? "-1rem" : "0", }}>
        303-1 : Interactions with water as a shared resource{" "}
      </p>
      {/* a */}
      <Box sx={{ mt: "-1rem" }}>
        {inputData?.map((el) => (
          <StaticColumn
            {...{
              inputData: el,
              completeData: inputData,
              tables: el[0].tables,
              setTables: el[0].setTables,
              errors: el?.[0]?.errors,
              setErrors: el?.[0]?.setErrors,
              data: data,
              defaultSegments: el[0]?.defaultSegments,
              defaultWidth: "16rem",
              parameter: el[0]?.paramater,
              defaultUnit,
              setDefaultUnit,
              totalField: "quntity",
              disabled1: true,
              defaultField: "unit",
              id: id,
              disabled: disabled,
            }}
          />
        ))}
      </Box>
      {questionData.map((el) => (
        <Box sx={{ mt: hide ? "-0.5rem" : "0.5rem", paddingleft: "-2rem" }}>
          <Box sx={{ display: "flex", gap: 1 }}>
            {/* <p className={styles.ques_heading}>{el.letter}</p> */}
            <p className={styles.ques_heading}>{el.title}</p>
          </Box>
          <Box sx={{ ml: 2, width: "98%" }}>
            <InputField
              placeholder={"Enter Text"}
              fieldName={el.fieldName}
              value={formData?.[el.fieldName]}
              handleChange={handleChange}
              mt="-5px"
              errors={errors[el.fieldName] && true}
              disabled={disabled}
            />
            <p
              color="error"
              variant="caption"
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                marginTop: "5px",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
              }}
            >
              {errors[el.fieldName]}
            </p>
          </Box>
        </Box>
      ))}
      
    </>
  )
  
  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
        <Box sx={{ ml: "1rem", width: "98%" }}>
          <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
        </Box>
      ) : (
        <Box textAlign="right" sx={{ mt: 3 }}>
          <Button
            onClick={handleSubmit}
            variant="contained"
            sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
          >
            Save & Continue <EastIcon sx={{ ml: 2 }} />
          </Button>
        </Box>
      )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI303_1;
